import { PolicyGuard } from '@/components/guards/PolicyGuard'
import { PaymentLogDetail } from '../pages/PaymentLogDetail'
import { PAYMENT_LOG_DETAIL_POLICIES } from '../constants/reportPolicies'

export function PaymentLogDetailRoute({
  source = 'payment_log',
}: {
  source?: 'payment_log' | 'payment_adjustment'
}) {
  return (
    <PolicyGuard requiredPolicies={[...PAYMENT_LOG_DETAIL_POLICIES]}>
      <PaymentLogDetail source={source} />
    </PolicyGuard>
  )
}
